import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CORE_CONFIG } from '../environment';
import { Observable } from 'rxjs';
import { NewEmailRequest } from './marketing-models';

@Injectable({
  providedIn: 'root'
})
export class MarketingService {

  private _baseURL: string;

  constructor(private httpClient: HttpClient,
    @Inject(CORE_CONFIG) private coreConfig: any) {
    this._baseURL = `${this.coreConfig.endpoint}/api/v1/marketing`;
  }

  sendEmail(newEmailRequest: NewEmailRequest): Observable<any> {
    return this.httpClient.post(`${this._baseURL}`, newEmailRequest);
  }
}
